module.exports = __webpack_public_path__ + "img/plain_btc.93223e18.svg";